'use strict';

function PublicationCollabrationService($resource, config) {
  return $resource(config.apiBase + '/publication-collabrations/:publicationId', {}, {
    'update': { method:'PUT' },
    'queryFiles': {
    	url: config.apiBase + '/publication-collabrations/:publicationId/files',
    	method: 'GET',
    	isArray: true
    },
    'getFileToken': {
      method: 'POST',
      url: config.apiBase + '/publication-collabrations/:publicationId/files/:fileId/tokens'
    },
    'getPreview': {
      method: 'GET',
      url: config.apiBase + '/publication-collabrations/:publicationId/files/:fileId/preview'
    }
  });
}

angular.module('dokiv')
  .factory('PublicationCollabrationService', ['$resource', 'config', PublicationCollabrationService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/publication-collabrations/PublicationCollabrationService.js
// module id = 432
// module chunks = 0